import { format, parseISO, differenceInYears, isAfter } from 'date-fns/esm'
import { frCA } from 'date-fns/esm/locale'
import store from '@/store/index'

export const formatMMDDYY = function (date) {
  const timeString = date.split(' ').join('T') + 'Z'
  if (store.getters['Locale/lang'] === 'fr') {
    return format(new Date(timeString), 'MMMM dd, yyyy', {
      locale: frCA
    })
  } else {
    return format(new Date(timeString), 'MMMM dd, yyyy')
  }
}

export
const diffInYears = function (leftDate, rightDate) {
  let lDate = leftDate
  let rDate = rightDate
  if (typeof leftDate === 'string') {
    lDate = parseISO(leftDate)
  }
  if (typeof rightDate === 'string') {
    rDate = parseISO(rightDate)
  }
  return differenceInYears(rDate, lDate)
}

export function formatDateTime (date) {
  if (store.getters['Locale/lang'] === 'fr') {
    const _date = format(new Date(date + 'Z'), 'MMMM dd, yyyy', {
      locale: frCA
    })
    const time = format(new Date(date + 'Z'), 'hh:mm aaaa', { locale: frCA })
    return { _date, time }
  } else {
    const _date = format(new Date(date + 'Z'), 'MMMM dd, yyyy')
    const time = format(new Date(date + 'Z'), 'hh:mm aaaa')
    return { _date, time }
  }
}

export function dateIsAfter (leftDate, rightDate) {
  const timeString = rightDate + 'Z'
  return isAfter(new Date(timeString), leftDate)
}
